import styled from 'styled-components';

export const ImageWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  & > img {
    max-width: 100%;
  }
`;
